<template>
<div style=" height: 100%; margin-top:10px">
    <div class="table2 pt-15 row">
        <h2 class="title-txt"></h2>
        <div class="col-md-3">
            <div class="total_user tu1">
                <div class="user">
                    <div style="background: #F1FFF8;" class="totaluser_chart"><span style="color: #8CD0B0;"><i class="fas fa-2x fa-users"></i></span></div>
                    <div class="text">
                        <h5><strong>Total Transactions</strong></h5>
                        <h2>{{analytics.total}}</h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="total_user tu2">
                <div class="user">
                    <div style="background: #FFF6EF;" class="totaluser_chart"><span style="color: #FFCCA8;"><i class="fas fa-2x fa-certificate"></i></span></div>
                    <div class="text">
                        <h5><strong>Succesful Transactions</strong></h5>
                        <h2>{{analytics.successful}}</h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="total_user tu3">
                <div class="user">
                    <div style="background: #FCF1FF;" class="totaluser_chart"><span style="color: #B874FD;"><i class="fas fa-2x fa-chart-pie"></i></span></div>
                    <div class="text">
                        <h5>Pending Transsactions</h5>
                        <h2>{{analytics.pending}}</h2>
                    </div>

                </div>

            </div>
        </div>
        <div class="col-md-3">
            <div class="total_user tu4">
                <div class="user">
                    <div style="background: #C7E7FB;" class="totaluser_chart"><span style="color: #6BC5FC;"><i class="fas fa-2x fa-chart-pie"></i></span></div>
                    <div class="text">
                        <h5>Failed Transactions</h5>
                        <h2>{{analytics.failed}}</h2>
                    </div>

                </div>

            </div>
        </div>
    </div>
    <!-- <div class="row">
        <button style="" class="all_user3" v-if="goBack" @click="bcktoConfigure"><span><i class="fas fa-arrow-left"></i></span> Back to Configure Dashboard</button>
    </div> -->
    <div class="col-md-12" style="margin-top:50px">
        <div class="row" style="padding:0; margin:0">

            <v-row style="margin:0 !important; padding:0 !important">
                <v-col cols="12" style="">
                    <div class="row">
                        <div class="col-md-5 mb-8">
                            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search Users List" single-line hide-details></v-text-field>

                        </div>
                        <div class="col-md-5 mb-8"> </div>

                        <v-spacer></v-spacer>
                    </div>
                    <!-- <v-dialog v-model="dialog" persistent transition="" max-width="500px">

                        <v-card>
                            <v-card-title style="color:#666; font-size:18px">
                                <span v-if="useredit=='1'">Add user</span>
                                <span v-if="useredit=='2'">Edit user</span>

                                <v-spacer></v-spacer>
                                <v-icon @click="openClose(2)">mdi-close-circle</v-icon>

                            </v-card-title>
                            <v-divider style="margin-top:0px"></v-divider>

                            <v-card-text>
                                <v-row>
                                    <div class="col-md-12 pa-8">
                                        <v-text-field type="text" v-model="firstname" name="Firstname" id="" placeholder="First Name" outlined dense label="First Name"> </v-text-field>

                                        <v-text-field type="text" v-model="lastname" name="Lastname" id="" placeholder="Last Name" outlined dense label="Last Name"></v-text-field>
                                        <v-text-field type="text" class="x" v-model="email" name="" id="" placeholder="E-mail Address of the User" label="Email Address" dense outlined :readonly="useredit==2" :disabled="useredit==2"></v-text-field>

                                        <v-select v-model="dept" :items="deptselect" :menu-props="{ maxHeight: '400' }" label="Select User Department" persistent-hint></v-select>
                                        <v-select v-model="rolefield" :items="rolesselect" :menu-props="{ maxHeight: '400' }" label="Select User Roles" multiple persistent-hint></v-select>
                                    </div>

                                </v-row>
                                <v-card-actions>

                                    <div style="color:white" v-if="useredit == '2'">
                                        <button type="button" class="btn btn-success" @click="edUserfun()">Edit User</button>

                                    </div>
                                    <div style="color:white" v-if="useredit == '1'">
                                        <button type="button" class="btn btn-success" @click="addUserfun">Add User</button>

                                    </div>
                                </v-card-actions>
                            </v-card-text>

                        </v-card>
                    </v-dialog> -->
                    <v-card>
                        <v-data-table :headers="headers" :items="desserts" :search="search" class="pa-0 elevation-2" :items-per-page="20">
                            <template v-slot:[`item.sn`]="{ item }" >
                                <tr>
                                    <td class="table-txt">{{desserts.map(function(x) {return x.transactionRef; }).indexOf(item.transactionRef)+1}}</td>
                                </tr>
                            </template>
                            <template v-slot:[`item.agentID`]="{ item }">
                <a
                 @click="$router.push(`/agentDetails/${item.agentID}`)"
                >
                  {{item.agentID}}
                </a>

              </template>
              <template v-slot:[`item.amount`]="{ item }">
                
                 <div>&#8358;{{formatPrice(item.amount+'.00')}}</div> 

              </template>
                            <template v-slot:[`item.roles`]="{ item }">
                                <span class="" v-for="(role,index) in item.roles" :key="index">{{ role.name }},</span>
                            </template>
                            <template v-slot:[`item.user_since`]="{ item }">
                                <td class="table-txt">{{ item.user_since }}</td>
                            </template>
                            <template v-slot:[`item.actions`]="{ item }">
                                <v-menu transition="slide-x-transition" bottom right>
                                    <template v-slot:activator="{ on: menu, attrs }">
                                        <v-btn style="background: #e5e5e5; padding: 4px 10px" small text class="ml-3 my-2" v-bind="attrs" v-on="{ ...menu }">
                                            <span style="color: grey; font-size: 20px">
                                                <i class="fas fa-ellipsis-h"></i>
                                            </span>
                                        </v-btn>
                                    </template>
                                    <v-card style="display: flex; flex-direction: column; text-align: center; padding: 10px 0">
                                        <v-btn text color="secondary" @click="editUser(item)">
                                            <h6 style="font-size: 14px">
                                                Edit User
                                            </h6>
                                        </v-btn>
                                        <!-- <v-btn text color="secondary" @click="editItem(item)">
                           <h6 style="font-size: 14px">
                               Edit Permission
                           </h6>
                       </v-btn> -->
                                        <v-btn text color="secondary" @click="deletUser(item,1)">
                                            <h6 style="font-size: 14px">
                                                Delete User
                                            </h6>
                                        </v-btn>
                                        <!-- <v-btn text color="secondary" @click="deletUser(item,2)">
                           <h6 style="font-size: 14px">
                               Block User
                           </h6>
                       </v-btn> -->
                                    </v-card>
                                    <!-- <v-list>
                       <v-list-item v-for="(item, i) in items" :key="i">
                           <v-list-item-title>{{ item.title }}</v-list-item-title>
                       </v-list-item
                   </v-list> -->
                                </v-menu>
                            </template>
                            <template v-slot:[`item.status`]="{item}">
                                <td class="table-txt">{{ item.status }}</td>
                            </template>
                            
                        </v-data-table>
                    </v-card>
                </v-col>
            </v-row>
        </div>

    </div>

</div>
</template>

<script>
import axios from "axios";
export default {
    data() {
        return {search:'',
            headers: [{
                    text: 'S/N',
                    align: 'start',
                    value: 'sn',
                    class: 'grey lighten-4 text-center title',
                },
                {
                    text: 'Agent ID',
                    value:'agentID',
                    class: 'grey lighten-4 text-center title',
                },
                {
                    text: 'Terminal ID',
                    value: 'terminalID',
                    class: 'grey lighten-4 text-center title',
                },
                {
                    text: 'Transaction Date',
                    value: 'transactionDate',
                    class: 'grey lighten-4 text-center title',
                },
                {
                    text: 'Amount',
                    value: 'amount',
                    class: 'grey lighten-4 text-center title',
                },
                {
                    text: 'Fee',
                    value: 'fee',
                    class: 'grey lighten-4 text-center title',
                },
                {
                    text: 'Transaction ID',
                    value: 'transactionRef',
                    class: 'grey lighten-4 text-center title',
                },
                {
                    text: 'Type',
                    value: 'transactionType',
                    class: 'grey lighten-4 text-center title',

                },
                {
                    text: 'Status',
                    value: 'transactionStatus',
                    class: 'grey lighten-4 text-center title',

                },
                {
                    text: 'Card Type',
                    value: 'cardType',
                    class: 'grey lighten-4 text-center title',

                },
                {
                    text: 'Bank',
                    value: 'bank',
                    class: 'grey lighten-4 text-center title',

                }
            ],
            desserts: [],
            analytics: {}

        }
    },
    mounted() {
        this.getTransDetails();
        console.log('llllolllollol');
    },

    methods: {
        formatPrice(value) {
        let val = value.split('.')
        var valuex = val[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+'.'+val[1]
        return valuex
    },
        pushData(x){
            const filter = this.desserts.filter(function(e){
                return e.agentID == x
            })
            const data = window.btoa(JSON.stringify(filter));
            return data
        },
        getTransDetails() {
            const url = process.env.VUE_APP_UB_V1_API_ENDPOINT+'fetch-transactions'
            axios.get(
                url
            ).then((response) => {
                if (response.data.code == 's200') {
                    this.analytics = response.data.message.analytics;
                    this.desserts =response.data.message.transactions
                    // response.data.message.transactions.forEach(el => {
                    //     this.desserts.push({
                    //         full_name: el.agentId,
                    //         email: el.transactionDate.split('T')[0],
                    //         roles: el.amount,
                    //         created_at: el.transactionId,
                    //         status: el.transactionStatus == 1 ? 'Successful' : el.transactionStatus == 2 ? 'Fail' : 'Pending',
                    //         actions: el.bank
                    //     })
                    // })
                    // this.$toast.open({
                    //     message: response.data.message,
                    //     type: 'success',
                    //     position: 'top-right'
                    // });
                }
            }).catch(e => {
                this.$toast.open({
                    message: e.response.data.message,
                    type: 'error',
                    position: 'top-right'
                    // all of other options may go here
                });
            })

        }
    }

}
</script>

<style lang="scss" scoped>
@import url('https://fonts.cdnfonts.com/css/circular-std');

.text {

    margin-top: -10px;

    h6 {
        font-style: normal;
        font-weight: 400;
        font-size: 13px;
        line-height: 20px;
        color: #4F4F4F;
    }

    h2 {
        font-family: 'Inter' !important;
        font-style: normal;
        font-weight: 500;
        font-size: 28px !important;
        line-height: 20px;
        color: #4F4F4F;
    }
}

.total_user {
    width: 100%;
    height: 149px;
    background: #fff;

    .user {
        width: 100%;
        display: flex;
        padding-top: 10%;

        .totaluser_chart {
            text-align: center;
            width: 40%;
            height: 50px;
            margin-top: 0%;
            width: 50px;
            padding: 10px;
            margin-left: 50px;
            margin-right: 25px
        }
    }
}

.tu1 {
    border-bottom: 4px solid #5DB68B;
}

.tu2 {
    border-bottom: 4px solid #FFCCA8;
}

.tu3 {
    border-bottom: 4px solid #B874FD;
}

.tu4 {
    border-bottom: 4px solid #6BC5FC;
}
</style>
